import React from 'react'
import { ContentfulModules } from '../helpers/modules'
import { useEntities } from '../helpers/selectors'
import { Select } from '../../atoms'

const Pills = ({ pills = [] }) => {
  const { buttons, panels } = pills.reduce<{ buttons: JSX.Element[]; panels: JSX.Element[] }>(
    (result, { content, title }, index) => {
      result.buttons.push(
        <button key={index} className={`Pills__pill ${index === 0 ? 'active' : ''}`}>
          {title}
        </button>,
      )
      result.panels.push(
        <div key={index} className={`Panels__panel ${index === 0 ? 'active' : ''}`}>
          <ContentfulModules modules={[content]} />
        </div>,
      )
      return result
    },
    { buttons: [], panels: [] },
  )

  const dropdownOptions = pills.map((p) => ({ text: p.title, value: p.title }))

  return (
    <div className='PillsContainer' data-pills>
      <div className='Pills'>{buttons}</div>

      <div className='Dropdown'>
        <Select
          name='pills-mobile-dropdown'
          value={dropdownOptions.length > 0 ? dropdownOptions[0].value : ''}
          options={dropdownOptions}
          brand='money'
        />
      </div>

      <div className='Panels'>{panels}</div>
    </div>
  )
}

const PillsConnected = ({ entries }) => {
  const pills = useEntities(entries)

  return <Pills pills={pills} />
}

export default PillsConnected
